module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_09-114b24b8a15042c2f84f3725ec34b3da.svg";